import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  serverError: false,
  freeswitchError: false,
  sipError: false,
  sipErrorMessage: "",
};

export const networkReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.NETWORK_ERROR_ALERT:
      if (
        action.payload.error === "serverError" &&
        state.serverError === false
      ) {
        state = {
          ...state,
          serverError: true,
        };
      } else if (
        action.payload.error === "freeswitchError" &&
        state.freeswitchError === false
      ) {
        state = {
          ...state,
          freeswitchError: true,
        };
      }
      break;
    case ActionTypes.NETWORK_CLEAR_ALERT:
      if (
        action.payload.error === "serverError" &&
        state.serverError === true
      ) {
        state = {
          ...state,
          serverError: false,
        };
      } else if (
        action.payload.error === "freeswitchError" &&
        state.freeswitchError === true
      ) {
        state = {
          ...state,
          freeswitchError: false,
        };
      }
      break;
    case ActionTypes.SIP_ERROR_ALERT:
      state = {
        ...state,
        sipError: true,
        sipErrorMessage: action.payload.message,
      };
      break;
    case ActionTypes.SIP_CLEAR_ALERT:
      state = {
        ...state,
        sipError: false,
        sipErrorMessage: "",
      };
      break;
    default:
      break;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/networkReducer.js